import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_INFO__base extends INVOCATION__base {
  /*
   *
   */
  /*
   *
   */
  get family() {
    return ENUM__ml_asset_family.NONE;
  }
}
